import {createSlice} from '@reduxjs/toolkit'

import processPostCartUpsell from '../thunks/processPostCartUpsell'
import updatePostCartUpsellPrice from '../thunks/updatePostCartUpsellPrice'
import processOrder from '../thunks/processOrder'

const initialState = {
  // Data from server
  data: [],
  // Status and error
  status: '',
  error: null,
  // Local state
  upsellKey: 0
}

const postCartUpsellsSlice = createSlice({
  name: 'postCartUpsells',
  initialState,
  reducers: {
    // Update the current upsells quantity
    updatePostCartUpsellQuantity (state, action) {
      state.data[0].order_offer_quantity = action.payload

      state.status = 'idle'
    },
    // Update the current upsells offer option
    updateOfferOption (state, action) {
      const {item_option_id, item_option_value_id} = action.payload
      if(state.data && state.data[0]) {
        if(!state.data[0].order_offer_item_options) {
          state.data[0].order_offer_item_options = [{
            item_option_id, item_option_value_id
          }]
        } else {
          state.data[0].order_offer_item_options = state.data[0].order_offer_item_options.filter(item_option => item_option.item_option_id !== item_option_id).concat([{
            item_option_id, item_option_value_id
          }])
        }
      }

      state.status = 'idle'
    },
    // Force a change in the state
    changePostCartUpsellsStatus (state, action) {
      state.status = action.payload
    }
  },
  extraReducers: {
    // On processing an order, fetch the upsells from the transaction
    [processOrder.fulfilled]: (state, action) => {
      state.status = 'succeeded'

      if(action.payload.data.upsells) {
        state.data = action.payload.data.upsells
      }
    },
    [processPostCartUpsell.pending]: (state) => {
      state.status = 'loading'
    },
    // Remove the first item of the array on processing upsell
    [processPostCartUpsell.fulfilled]: (state) => {
      state.status = 'succeeded'

      state.data.shift()
      state.upsellKey++
    },
    [processPostCartUpsell.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    [updatePostCartUpsellPrice.pending]: (state) => {
      state.status = 'loading'
    },
    // Update upsell price
    [updatePostCartUpsellPrice.fulfilled]: (state, action) => {
      state.status = 'succeeded'

      if(state.data.length) {
        state.data.forEach(({offer_id}, index) => {
          if(action.payload.offer_id === offer_id) {
            state.data[index] = {...state.data[index], offer_price: action.payload.order_offer_price, discount_label: action.payload.discount_label, subtotal: action.payload.subtotal, total: action.payload.total}
          }
        })
      }
    },
    [updatePostCartUpsellPrice.failed]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    }
  }
})

export default postCartUpsellsSlice.reducer

export const {
  updatePostCartUpsellQuantity,
  changePostCartUpsellsStatus,
  updateOfferOption
} = postCartUpsellsSlice.actions



// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/postCartUpsellsSlice.js